module.exports = __webpack_public_path__ + "img/zs2.8c03ac2b.jpg";